export const toTitleCase = (word = '') => {
  return word.charAt(0).toUpperCase() + word.slice(1);
};

export const capitalizeAllFirstLetters = sentence => {
  const words = sentence.split(' ');
  const formattedWords = words.map(word => {
    return toTitleCase(word);
  });
  return formattedWords.join(' ');
};
